export const API_BASE_URL = "http://localhost:8000/";
export const LOGOUT_API = "http://localhost:8000/api/logout";
export const IMG_API = "http://localhost:8000/images";
